import { render } from "./CustomSectionComponent.vue?vue&type=template&id=bb56bf9e&ts=true"
import script from "./CustomSectionComponent.vue?vue&type=script&lang=ts"
export * from "./CustomSectionComponent.vue?vue&type=script&lang=ts"

import "@/assets/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__